module.exports = __webpack_public_path__ + "static/media/31.8052ee56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/31.svg
// module id = 2822
// module chunks = 3